import React from 'react';

// import AttendeesLink from '~/components/links/AttendeesLink';
import { breakpoints, colors, css, fluidRange, fontSmoothing, respondTo, styled } from '~/styles';
import LogoImg from '~/assets/images/revance-u-logo-v2-white.svg';
import ExternalLink from '~/components/common/ExternalLink';


const logoOnTopThreshold = 450;
const StyledFooter = styled.footer`
  background: ${colors.black};
  color: ${colors.white};
  /* ${fontSmoothing}; */
  white-space: nowrap;
  line-height: 70px;

  ${fluidRange(
    'fontSize', '10px', '11.5px', breakpoints.xs, breakpoints.md
  )}
  font-weight: 500;
  z-index: 4;

  nav {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }

  // = same as for BottomBlockLink
  ${fluidRange(
    'paddingLeft', '20px', '30px', breakpoints.xs, breakpoints.lg
  )}
  ${fluidRange(
    'paddingRight', '20px', '30px', breakpoints.xs, breakpoints.lg
  )}

  ${respondTo(logoOnTopThreshold, css`
    line-height: 40px;
  `)}
`


const NavPrimary = styled.ul`
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;

  ${respondTo(logoOnTopThreshold, css`
    justify-content: center;
    width: 100%;
  `)}

  li {

    a, &.nolink {
      position: relative;
      ${fluidRange('paddingLeft', '10px', '30px', breakpoints.lg, breakpoints.max)};
      ${fluidRange('paddingRight', '10px', '30px', breakpoints.lg, breakpoints.max)};
      display: inline-block;

      // separator
      &:after {
        content: '';
        position: absolute;
        width: 1px;
        height: 1em;
        background: ${colors.white};
        border-radius: 50%;

        right: 0;
        top: 48%;
        transform: translateY(-50%);
      }
    }


    &:first-of-type {
      a, &.nolink {
        padding-left: 0;
      }
    }

    &:last-of-type {
      a, &.nolink {
        &:after {
          display: none;
        }
      }
    }

    &.footer-logo {
      padding-right: 15px;

      img, svg {
        width: 25px;
        vertical-align: middle;
        transform: translateY(-5%);
      }
      &:after {
        display: none;
      }

      ${respondTo(logoOnTopThreshold, css`
        display: block;
        width: 100%;
        text-align: center;
        padding: 20px 0 5px;

        img, svg {
          height: 45px;
        }
      `)}
    }


    ${respondTo(logoOnTopThreshold, css`
      &:nth-of-type(2) {
        a, &.nolink {
          padding-left: 0;
        }
      }
    `)}
  }
`

const NavSecondary = styled.ul`

`

function YearToDate() {
  return (new Date().getFullYear());
}

const PageFooter = () => (
  <StyledFooter>
    <nav>
      <NavPrimary>
        <li className='footer-logo nolink'>
          <img src={LogoImg} alt='RevanceU' />
        </li>
        <li className='nolink'>
          &copy; Copyright {YearToDate()}
        </li>
        <li className='nolink'>
          All Rights Reserved
        </li>
        <li>
          <ExternalLink href='https://www.revance.com/privacy-policy/'>Privacy Policy</ExternalLink>
        </li>
        <li>
          <ExternalLink href='https://www.revance.com/company/contact-us/'>Contact</ExternalLink>
        </li>
      </NavPrimary>
      {/* <NavSecondary>
        <li className='desktop-only'>
          <AttendeesLink />
        </li>
      </NavSecondary> */}
    </nav>
  </StyledFooter>
)
export default PageFooter;


// WEBPACK FOOTER //
// ./src/components/layout/PageFooter.tsx